// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-jsx": require("gatsby-module-loader?name=component---src-pages-404-jsx!/opt/build/repo/src/pages/404.jsx"),
  "component---src-pages-index-jsx": require("gatsby-module-loader?name=component---src-pages-index-jsx!/opt/build/repo/src/pages/index.jsx")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/opt/build/repo/.cache/json/404.json"),
  "en-404.json": require("gatsby-module-loader?name=path---en-404!/opt/build/repo/.cache/json/en-404.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/opt/build/repo/.cache/json/index.json"),
  "en.json": require("gatsby-module-loader?name=path---en!/opt/build/repo/.cache/json/en.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/opt/build/repo/.cache/json/404-html.json"),
  "en-404-html.json": require("gatsby-module-loader?name=path---en-404-html!/opt/build/repo/.cache/json/en-404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-jsx!/opt/build/repo/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js